"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpotCacheManage = void 0;
const rxjs_1 = require("rxjs");
const api_1 = require("../api");
// 内存缓存 map
const SymbolMap = new Map();
// 内存缓存 array
let SymbolArr = new Array();
var SpotCacheManage;
(function (SpotCacheManage) {
    function updateMemoryCache(arr) {
        SymbolArr = arr;
        arr.forEach((e) => SymbolMap.set(e.symbol, e));
    }
    SpotCacheManage.updateMemoryCache = updateMemoryCache;
    function getExchangeSymbol(symbol) {
        return SymbolMap.get(symbol);
    }
    SpotCacheManage.getExchangeSymbol = getExchangeSymbol;
    function getExchangeSymbols(forceUpdate = false) {
        if (forceUpdate) {
            return (0, api_1.getSpotMarkets)();
        }
        else {
            return (0, rxjs_1.of)(SymbolArr);
        }
    }
    SpotCacheManage.getExchangeSymbols = getExchangeSymbols;
})(SpotCacheManage = exports.SpotCacheManage || (exports.SpotCacheManage = {}));
